module.exports = __webpack_public_path__ + "static/media/S4C_THUMBNAIL.c87f9fe8.png";